import { Box, Button, Chip, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@material-ui/core"
import { useFormik } from "formik"
import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { NamedRoutes } from "../../../../../routes"
import { useStyles } from "./Styles"
import { externalEntityGroupFormValidation } from "../../../../../utils/validationSchema"
import { useHistory } from "react-router-dom"
import { FormLoader } from "../../../../Loader/FormLoader"

const ExternalEntityGroupForm = ({ externalEntityGroupData, onSubmit, externalServiceHandlers }) => {
  const intl = useIntl()
  const classes = useStyles()
  const history = useHistory()
  const [referenceText, setReferenceText] = React.useState('')
  // const [selectedReferences, setSelectedReferences] = React.useState(externalEntityGroupData?.references?.map(ref => ref.entity_reference) || [])
  const ExternalEntityGroupForm = useFormik(
    {
      initialValues: {
        name: externalEntityGroupData?.name || '',
        entity_type: externalEntityGroupData?.entity_type || '',
        entity_references: externalEntityGroupData?.references?.map(ref => ref.entity_reference) || []
      },
      validateOnMount: true,
      validateOnBlur: false,
      validateOnChange: true,
      validationSchema: externalEntityGroupFormValidation,
      onSubmit: ((values, actions) => {
        const ExternalEntityGroupFormPayload = {
          name: values.name,
          entity_type: values.entity_type,
          entity_references: values.entity_references
        }
        onSubmit(ExternalEntityGroupFormPayload, actions)
      })
    }
  )
  const handleReferenceKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      event.stopPropagation()
      if (!!referenceText.trim() && !ExternalEntityGroupForm.values.entity_references.includes(referenceText.trim())) {
        ExternalEntityGroupForm.setFieldValue('entity_references', [...ExternalEntityGroupForm.values.entity_references, referenceText.trim()])
        setReferenceText('')
      }
    }
  }

  const handleReferenceRemove = (reference) => {
    const newEntityReferences = ExternalEntityGroupForm.values.entity_references.filter(ref => ref !== reference)
    ExternalEntityGroupForm.setFieldValue('entity_references', newEntityReferences)
  }
  return (
    <form onSubmit={ExternalEntityGroupForm.handleSubmit} noValidate autoComplete="off"
      className={classes.formWrapper}>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="UserGroup.Name">
          <FormattedMessage id='Fields.label.ExternalEntityGroupName' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'UserGroup.placeholder.UserGroupName' })}
            id="UserGroup.Name"
            type={'text'}
            margin="dense"
            variant="outlined"
            name='name'
            value={ExternalEntityGroupForm.values.name}
            onChange={ExternalEntityGroupForm.handleChange}
            onBlur={ExternalEntityGroupForm.handleBlur}
            helperText={ExternalEntityGroupForm.errors.name && ExternalEntityGroupForm.touched.name && ExternalEntityGroupForm.errors.name}
            error={ExternalEntityGroupForm.errors.name && ExternalEntityGroupForm.touched.name !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="ExternalEntityGroup.EntityType">
          <FormattedMessage id='Fields.label.EntityType' />
        </InputLabel>
        <FormControl variant="outlined">
          <Select
            labelId="ExternalEntityGroup.EntityType"
            id="ExternalEntityGroup.EntityType"
            name="entity_type"
            value={ExternalEntityGroupForm.values.entity_type}
            onChange={ExternalEntityGroupForm.handleChange}
            onBlur={ExternalEntityGroupForm.handleBlur}
            displayEmpty
            error={ExternalEntityGroupForm.errors.entity_type && ExternalEntityGroupForm.touched.entity_type !== undefined}
            margin="dense"
          >
            <MenuItem value="" disabled>
              {intl.formatMessage({ id: 'ExternalEntityGroup.placeholder.EntityType' })}
            </MenuItem>
            {externalServiceHandlers.map((handler) => (
              <MenuItem key={handler.key} value={handler.key}>
                {handler.label}
              </MenuItem>
            ))}
          </Select>
          {ExternalEntityGroupForm.errors.entity_type && ExternalEntityGroupForm.touched.entity_type && (
            <FormHelperText error={true}>{ExternalEntityGroupForm.errors.entity_type}</FormHelperText>
          )}
        </FormControl>
      </div>


      <div className={classes.BasicInfoRow}>
        <InputLabel id="ExternalEntityGroup.EntityReferences">
          <FormattedMessage id='Fields.label.EntityReferences' />
        </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'ExternalEntityGroup.placeholder.EntityReferences' })}
            id="ExternalEntityGroup.References"
            type={'text'}
            margin="dense"
            variant="outlined"
            name="entity_references"
            value={referenceText}
            onKeyPress={handleReferenceKeyPress}
            onChange={(e) => setReferenceText(e.target.value)}
            onBlur={() => {
              ExternalEntityGroupForm.setFieldTouched('entity_references', true)
              if (ExternalEntityGroupForm.values.entity_references.length === 0)
                ExternalEntityGroupForm.setFieldError('entity_references', intl.formatMessage({ id: 'validationSchema.required' }))
            }}
            helperText={ExternalEntityGroupForm.errors.entity_references && ExternalEntityGroupForm.touched.entity_references && ExternalEntityGroupForm.errors.entity_references}
            error={!!ExternalEntityGroupForm.errors.entity_references && ExternalEntityGroupForm.touched.entity_references !== undefined}
          />
          {
            ExternalEntityGroupForm.values.entity_references.length > 0 && (
              <Box className={classes.selectedUsersBox}>
                {ExternalEntityGroupForm.values.entity_references.map((reference) => (
                  <Chip
                    key={reference}
                    label={reference}
                    onDelete={() => handleReferenceRemove(reference)}
                    className={classes.userChip}
                    color="primary"
                    variant="outlined"
                  />
                ))}
              </Box>
            )
          }
        </FormControl>
      </div>
      <div className={classes.SubmitRow}>
        <button
          type="submit"
          disabled={ExternalEntityGroupForm.isSubmitting || !ExternalEntityGroupForm.isValid}
          className={classes.AddAdminSubmit}
        >
          <FormattedMessage id='AdditionalInfo.button.submit' />
        </button>
        <Button onClick={() => history.push(NamedRoutes.subscription.externalEntityGroups.list)} color="primary">
          <FormattedMessage id='ChangePhone.DialogActions.cancel' />
        </Button>
      </div>
      {ExternalEntityGroupForm.isSubmitting && <FormLoader loading={true} />}
    </form>
  )
}

export default ExternalEntityGroupForm